module.exports = __webpack_public_path__ + "static/media/edit-profile-active.e66e51a2.svg";